import api from '../api/axios';

/**
 * Возвращает { url, errorCode }:
 *   - url: ObjectURL на PDF или null
 *   - errorCode: HTTP-статус (403/404/другой) или null при успехе
 */
export async function fetchPdfBlobUrl(articleId) {
  try {
    const resp = await api.get(`/articles/${articleId}.pdf?ts=${Date.now()}`, {
      responseType: 'blob',
    });
    const blob = new Blob([resp.data], { type: 'application/pdf' });
    return { url: URL.createObjectURL(blob), errorCode: null };
  } catch (e) {
    const status = e?.response?.status;
    if (status === 403) {
      return { url: null, errorCode: 403 };
    }
    if (status === 404) {
      return { url: null, errorCode: 404 };
    }
    return { url: null, errorCode: status || 'unknown' };
  }
}
